import React from 'react'
import PropTypes from "prop-types"

const RadioButton = ({ label, disabled, className, value, radioBtnList, handleRadioChange, elementStyle}) => {
    return <div className={className}>
        <label htmlFor={`${label}`} className="form-label">
            {label}
        </label>
        <div className="">
            {radioBtnList.map((state, index) =>
                <div className="form-check form-check-inline " key={index}>
                    <input
                        type="radio"
                        id={`${label}-radioButton-${index}`}
                        name="radioGroup"
                        className={`mt-2 pointer form-check-input `}
                        value={state.value}
                        checked={value === state.value}
                        onChange={handleRadioChange}
                        disabled={disabled}
                        style={elementStyle}
                    />
                    <label className='form-check-label' style={elementStyle} htmlFor={`${label}-radioButton-${index}`}>{state.label}</label>
                </div>
            )}
        </div>
    </div>
}


RadioButton.propTypes = {
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    handleRadioChange: PropTypes.func.isRequired,
    value: PropTypes.any,
    radioBtnList: PropTypes.array.isRequired,
    elementStyle:PropTypes.object
}
export default RadioButton